// ============================================================
// Tiny bilingual (FR/EN) store for UI chrome outside SurveyJS.
// SurveyJS handles its own localization; this covers the header,
// footer, home / about / privacy pages and the upload step.
// ============================================================
import { reactive } from 'vue'

const STORAGE_KEY = 'iopic_locale'

function initialLocale () {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'fr' || saved === 'en') return saved
  } catch { /* ignore */ }
  // Default to French (project's primary working language)
  return 'fr'
}

export const localeState = reactive({
  current: initialLocale()
})

export function setLocale (loc) {
  if (loc !== 'fr' && loc !== 'en') return
  localeState.current = loc
  try { localStorage.setItem(STORAGE_KEY, loc) } catch { /* ignore */ }
  try { document.documentElement.setAttribute('lang', loc) } catch { /* ignore */ }
}

/** Pick the string for the current locale from a { fr, en } object. */
export function t (dict) {
  if (dict == null) return ''
  if (typeof dict === 'string') return dict
  return dict[localeState.current] ?? dict.fr ?? dict.en ?? ''
}
